module.exports = (__webpack_require__(9446))("./index.js");